import { default as Modal } from "./AbstractModal";

export default class extends Modal {
    /**
     * The CSS class name to apply to `<html>` to mark the modal as open.
     *
     * @var {string}
     */
    activeClass = "has-menu-open";

    constructor(m) {
        super(m);

        // UI
        this.$anim = this.$("anim")[0];
        this.$aside = this.$("aside")[0];
        this.$scrollable = this.$("scrollable")[0];
    }

    ///////////////
    // Callbacks
    ///////////////
    onClose() {
        this.el.classList.remove("is-show");
        this.$anim.classList.remove("is-active");

        this.closeAccordions();
    }

    onOpen(args) {
        requestAnimationFrame(() => {
            this.el.classList.add("is-show");
            this.$anim.classList.add("is-active");

            this.call("close", null, "ModalProjects");
        });
    }

    ///////////////
    // Methods
    ///////////////
    closeAccordions() {
        const $accordions = this.el.querySelectorAll(
            "[data-module-accordions]"
        );
        let accordionsIndex = 0;

        while (accordionsIndex < $accordions.length) {
            const $accordion = $accordions[accordionsIndex];
            const moduleID = $accordion.dataset.moduleAccordions;
            this.call("close", null, "Accordions", moduleID);
            accordionsIndex++;
        }
    }
}
